import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl';
import { motion } from 'framer-motion'
import Logo from '../../components/Logo/Logo';
import Background from './components/Background/Background';
import phone from '../../assets/images/home_phone.png';

const Home = ({ history }) => {
    const handleClick = (event) => {
        event.preventDefault();
        history.push('/quiz');
    }
    return (
        <Fragment>
            <div className="container">
                <div className="grid">
                    <div className="grid__left grid__left--center">
                        <div className="home__illustration">
                            <Background motion={motion} />
                            <motion.div
                                className="phone"
                            >
                                <img src={phone} alt="phone" />
                            </motion.div>
                        </div>
                    </div>
                    <div className="grid__right grid__right--center">
                        <div className="home__intro">
                            <motion.h1
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: .6, type: "spring" }}
                            >
                                <FormattedMessage id="home.title" default="Learn to be attentive when using Smart-ID" />
                            </motion.h1>
                            <motion.p
                                className="lead"
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: .6, delay: .2, type: "spring" }}
                            >
                                <FormattedMessage id="home.lead" default="We’ve created a quick quiz to make sure you don’t fall for phishing attempts." />
                            </motion.p>
                            <motion.div
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: .6, duration: .4, type: "spring" }}
                            >
                                <button
                                    type="button"
                                    className="btn btn--primary"
                                    onClick={handleClick}
                                >
                                    <span className="label">
                                        <FormattedMessage id="home.button" default="Start the Quiz" />
                                    </span>
                                </button>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: .6, delay: .2 }}
            >
                <Logo />
            </motion.div>
        </Fragment>
    )
}

export default Home
